export default "__VITE_ASSET__BovGQDKg__"